import { render } from "./NewOrder.vue?vue&type=template&id=2bc4bbb8"
import script from "./NewOrder.vue?vue&type=script&lang=js"
export * from "./NewOrder.vue?vue&type=script&lang=js"

import "./NewOrder.vue?vue&type=style&index=0&id=2bc4bbb8&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/orders/NewOrder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2bc4bbb8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2bc4bbb8', __exports__)) {
    console.log('reload')
    api.reload('2bc4bbb8', __exports__)
  }
  
  module.hot.accept("./NewOrder.vue?vue&type=template&id=2bc4bbb8", () => {
    console.log('re-render')
    api.rerender('2bc4bbb8', render)
  })

}


export default __exports__